export enum TemplateStatisticType {
  Template = 0,
  Tag = 1
}
